/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Org_Contract_Badge_AwaitingInputs */



/**
* | output |
* | --- |
* | "Awaiting approval" |
*
* @param {Partner_Org_Contract_Badge_AwaitingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_org_contract_badge_awaiting = /** @type {((inputs?: Partner_Org_Contract_Badge_AwaitingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Org_Contract_Badge_AwaitingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Freigabe ausstehend")
	return /** @type {LocalizedString} */ ("Awaiting approval")
});